import {badgeStyle, BadgeStyle} from "./BasicBadge";
import {ReactNode} from "react";
import {IconAlertTriangleFilled, IconMessage2} from "@tabler/icons-react";
import MegaphoneIcon from "../icons/MegaphoneIcon";

export type BannerStyle = BadgeStyle;
export const bannerStyle = badgeStyle;

interface BannerProps {
    children?: React.ReactNode,
    style?: BannerStyle,
    text?: string | ReactNode,
    smallText?: string
    className?: string
}


const Banner: React.FC<BannerProps> = ({className = 'mt-3 mx-auto max-w-7xl px-2 md:px-6 lg:px-8', children, style = bannerStyle.success, text, smallText = text}) => {
    const Icon = style === bannerStyle.danger ? IconAlertTriangleFilled : bannerStyle.warning ? MegaphoneIcon : IconMessage2;
    return (
        <div className={className}>
            <div className={`rounded-lg ${style.bg} p-2 shadow-lg sm:p-3`}>
                <div className="flex flex-wrap items-center justify-between">
                    <div className="flex w-0 flex-1 items-center">
                        {/*<span className="flex rounded-lg bg-indigo-800 p-2">*/}
                        {/*</span>*/}
                        {children && children}
                        {!children &&
                            <>
                                <Icon className={`h-6 w-6 ${style.text}`} aria-hidden="true"/>
                                <p className={`ml-3 font-medium ${style.text}`}>
                                    <span className="md:hidden">{smallText}</span>
                                    <span className="hidden md:inline">{text}</span>
                                </p>
                            </>}
                    </div>
                    {/*<div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
                            <a
                                href="#"
                                className="flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-indigo-600 shadow-sm hover:bg-indigo-50"
                            >
                                Learn more
                            </a>
                        </div>
                        <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
                            <button
                                type="button"
                                className="-mr-1 flex rounded-md p-2 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white"
                            >
                                <span className="sr-only">Dismiss</span>
                                <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true"/>
                            </button>
                        </div>*/}
                </div>
            </div>
        </div>
    )
}
export default Banner;